import React from 'react';
import PropTypes from 'prop-types';
import { Td, Name as OrderNumber } from '@layout/Attendees';

export const OrderNumbers = ({ orders }) => (
  <table>
    <tbody>
      {orders.map(
        (orderNumber, index) =>
          orderNumber && (
            <tr key={orderNumber}>
              <Td>{index === 0 ? 'order number' : ''}</Td>
              <Td>
                <OrderNumber>{orderNumber}</OrderNumber>
              </Td>
            </tr>
          ),
      )}
    </tbody>
  </table>
);

OrderNumbers.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.string),
};

OrderNumbers.defaultProps = {
  orders: [],
};
export default OrderNumbers;



// WEBPACK FOOTER //
// ./components/atoms/OrderNumbers.js